import { render, staticRenderFns } from "./MaterielBatch.vue?vue&type=template&id=507acf90&scoped=true"
import script from "./MaterielBatch.vue?vue&type=script&lang=js"
export * from "./MaterielBatch.vue?vue&type=script&lang=js"
import style0 from "./MaterielBatch.vue?vue&type=style&index=0&id=507acf90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507acf90",
  null
  
)

export default component.exports